import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#0d1b2a', // Deep Indigo/Black
            light: '#1b263b',
            dark: '#000000',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#e0b1cb', // Muted Pink/Gold accent
            light: '#f5d0e6',
            dark: '#ae829b',
            contrastText: '#000000',
        },
        background: {
            default: '#f0f2f5',
            paper: '#ffffff',
        },
        text: {
            primary: '#1b263b',
            secondary: '#415a77',
        },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
            fontWeight: 700,
            color: '#0d1b2a',
            letterSpacing: '-0.5px',
        },
        h5: {
            fontWeight: 600,
            color: '#1b263b',
        },
        h6: {
            fontWeight: 600,
            color: '#415a77',
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
        },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
                elevation1: {
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                },
                elevation3: {
                    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    border: '1px solid rgba(0,0,0,0.05)',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0px 12px 30px rgba(0, 0, 0, 0.12)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '8px 16px',
                },
                containedPrimary: {
                    boxShadow: '0 4px 10px rgba(13, 27, 42, 0.2)',
                    '&:hover': {
                        boxShadow: '0 6px 15px rgba(13, 27, 42, 0.3)',
                    }
                }
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                },
                filled: {
                    border: '1px solid transparent',
                },
                outlined: {
                    border: '1px solid currentColor',
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: 'none',
                    backgroundColor: '#ffffff',
                    '& .MuiDataGrid-cell': {
                        borderBottom: '1px solid #f0f0f0',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#0d1b2a !important',
                        color: '#ffffff !important',
                        borderBottom: 'none',
                        fontSize: '0.9rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#0d1b2a !important',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 'bold',
                        color: '#ffffff !important',
                    },
                    // Fix icons in header
                    '& .MuiDataGrid-iconButtonContainer': {
                        color: '#ffffff !important',
                    },
                    '& .MuiDataGrid-menuIcon': {
                        '& .MuiSvgIcon-root': {
                            color: '#ffffff !important',
                        }
                    },
                    '& .MuiDataGrid-sortIcon': {
                        color: '#ffffff !important',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f8f9fa',
                    },
                },
            },
        },
    },
});

export default theme;
